(() => {
  const pathwayAltByFilename = {
    '01-daily-movement.png': 'Illustration representing daily movement support',
    '02-stress-nervous-system.png': 'Illustration representing stress and nervous system support',
    '03-recovery-circulation.png': 'Illustration representing recovery and circulation support',
    '04-heat-decompression.png': 'Illustration representing heat and decompression support',
    '05-restoration.png': 'Illustration representing restoration support'
  };

  const applyPathwayAlts = (root = document) => {
    root.querySelectorAll('img[src]').forEach((image) => {
      if ((image.getAttribute('alt') || '').trim()) return;

      const source = image.currentSrc || image.src || '';
      for (const [filename, alt] of Object.entries(pathwayAltByFilename)) {
        if (source.includes(filename)) {
          image.alt = alt;
          break;
        }
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => applyPathwayAlts(), { once: true });
  document.addEventListener('shopify:section:load', (event) => applyPathwayAlts(event.target));
})();
